<template>
  <div class="tw-mt-1 tw-w-full">
    <slot />
  </div>
</template>
